












































































































































































































































































import _ from 'lodash'
import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'
import { maskDateTime, formatDateGetApi } from '@/utils/common'
import { MensagensDaApiEnum } from '@/types/_'
import RegrasDeCalculoStore from '../../RegrasDeCalculo/Store/RegrasDeCalculoStore'

@Component
export default class ComponentModalGeracaoRepasses extends Vue {
  $refs!: { formGerarRepasse: any }

  menuAnoMesReferenciaGeracaoRepasse: boolean = false
  menuAnoMesReferenciaDoRepasse: boolean = false
  menuDataVencimentoGeracaoRepasse: boolean = false
  loadGerarRepasses: boolean = false
  isModalOpen: boolean = false
  previousSelectedFontesPagadoras: any = []
  statusDisparos: any = []
  searchPrestador: string = ''
  loadingPrs: boolean = false
  ignoreNextPrestadorSearch: boolean = false

  debounce = _.debounce((search) => this.getRegrasDeCalculoStore.getPrestadoresRepasse({ limite: 20, filtro: search }), 700)

  formGerarRepasseRules: any = {
    valid: true,
    fontePagadoraGerarRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    anoMesReferenciaDoRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    condicaoPagamentoGerarRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    dataVencimentoGeracaoRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    estabelecimentoGerarRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    anoMesReferenciaGeracaoRepasse: [(v: string) => !!v || 'Campo obrigatório'],
    getDateTime: [(v: string) => !!v || 'Campo obrigatório'],
  }

  get modalGerarRepasse() { return this.getFinanceiroStore.modal.gerarRepasse }
  set modalGerarRepasse(value: boolean) { this.getFinanceiroStore.setModal({ name: 'gerarRepasse', value }) }

  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get loadingGerarRepasses() {
    return this.loadGerarRepasses
  }

  set loadingGerarRepasses(value: boolean) {
    this.loadGerarRepasses = value
  }

  get getFontePagadoraGerarRepasse() {
    return [ { id: 'all', nome: 'Calcular todos os estabelecimentos do grupo (criar 1 geração por estabelecimento)' }, ...this.getFinanceiroStore.fontePagadoras]
  }

  set getFontePagadoraGerarRepasse(value: any[]) {
    this.getFinanceiroStore.setFontePagadora(value)
  }

  get getGerarRepassePrestadores() {
    return this.getRegrasDeCalculoStore.prestadoresRepasse
  }

  get fontePagadoraGerarRepasse() {
    return this.getFinanceiroStore.fontePagadoraId
  }

  set fontePagadoraGerarRepasse(value: any) {
    this.getFinanceiroStore.setFontePagadoraGerarRepasse(value)
  }

  get estabelecimentoGerarRepasse() {
    return this.getFinanceiroStore.estabelecimentoGerarRepasseId
  }

  set estabelecimentoGerarRepasse(value: any) {
    this.getFinanceiroStore.setEstabelecimentoGerarRepasse(value)
  }

  get prestadorGerarRepasse() {
    return this.getFinanceiroStore.prestadorGerarRepasse
  }

  set prestadorGerarRepasse(value: string) {
    this.getFinanceiroStore.setPrestadorGerarRepasse(value)
  }

  get condicaoPagamentoGerarRepasse() {
    return this.getFinanceiroStore.condicaoPagamentoGerarRepasseId
  }

  set condicaoPagamentoGerarRepasse(value: string) {
    this.getFinanceiroStore.setCondicaoPagamentoGerarRepasseId(value)
  }

  get getCondicaoPagamento() {
    return this.getFinanceiroStore.condicoesPagamento
  }

  set getCondicaoPagamento(value: any[]) {
    this.getFinanceiroStore.setCondicaoPagamento(value)
  }

  get getMenuAnoMesReferenciaGeracaoRepasse() {
    return this.menuAnoMesReferenciaGeracaoRepasse
  }

  set getMenuAnoMesReferenciaGeracaoRepasse(value: boolean) {
    this.menuAnoMesReferenciaGeracaoRepasse = value
  }

  get getMenuAnoMesReferenciaDoRepasse() {
    return this.menuAnoMesReferenciaDoRepasse
  }

  set getMenuAnoMesReferenciaDoRepasse(value: boolean) {
    this.menuAnoMesReferenciaDoRepasse = value
  }

  get anoMesReferenciaGeracaoRepasse() {
    return this.getFinanceiroStore.anoMesReferenciaGeracaoRepasse
  }

  set anoMesReferenciaGeracaoRepasse(value) {
    this.getFinanceiroStore.setAnoMesReferenciaGeracaoRepasse(value)
  }

  get anoMesReferenciaDoRepasse() {
    return this.getFinanceiroStore.anoMesReferenciaDoRepasse
  }

  set anoMesReferenciaDoRepasse(value) {
    this.getFinanceiroStore.setAnoMesReferenciaDoRepasse(value)
  }

  get getMenuAnoMesReferenciaDataVencimentoGeracaoRepasse() {
    return this.menuDataVencimentoGeracaoRepasse
  }

  set getMenuAnoMesReferenciaDataVencimentoGeracaoRepasse(value: boolean) {
    this.menuDataVencimentoGeracaoRepasse = value
  }

  get dataVencimentoGeracaoRepasse() {
    return this.getFinanceiroStore.dataVencimentoGeracaoRepasse
  }

  set dataVencimentoGeracaoRepasse(value) {
    this.getFinanceiroStore.setDataVencimentoGeracaoRepasse(value)
  }

  get getDateTime(): Date | null {
    return formatDateGetApi(this.getFinanceiroStore.dataEnvioNotaFiscalGeracaoRepasse)
  }

  set getDateTime(value: Date | null) {
    let formatDate: string = ''
    if (value) {
      formatDate = moment(value).format('YYYY-MM-DDTHH:mm')
    }

    this.getFinanceiroStore.setDataEnvioNotaFiscalGeracaoRepasse(formatDate)
  }

  @Watch('getDateTime')
  onGetDateTimeChanged(value: Date | null) {
    if (value) {
      this.isModalOpen = true
    }
  }

  get textFieldProps() {
    return { prependIcon: 'event' }
  }

  get datePickerProps() {
    return {
      locale: this.$vuetify.lang.current,
      color: 'rgb(38, 82, 163)',
      min: new Date(Date.now()).toISOString(),
    }
  }

  get timePickerProps() {
    return {
      format: '24hr',
      color: 'rgb(38, 82, 163)',
      min: '00:00',
      allowedMinutes: m => m % 5 === 0,
    }
  }
  
  autoSelectCondicaoPagamento() {
    const condicoes = this.getCondicaoPagamento || []
    if (condicoes.length !== 1 || this.condicaoPagamentoGerarRepasse) return

    this.condicaoPagamentoGerarRepasse = condicoes[0].id
  }

  closeModalGerarRepasse() {
    this.getFinanceiroStore.clearGeracaoRepasses()
    this.isModalOpen = false
    this.modalGerarRepasse = false
  }

  onChangeFontePagadoraGerarRepasse(selected: any[] | any) {
    const allIds = this.getFontePagadoraGerarRepasse
    
    const selectedWithoutAll = selected.filter((v: any) => v.id !== 'all');
    const hasAll = selected.some(val => val.id == 'all')
    
    const hadAll = this.previousSelectedFontesPagadoras.some(val => val.id == 'all')
    const allWasClicked = (hadAll && !hasAll) || (!hadAll && hasAll);
    let newValue = [...selected];
    
    if (allWasClicked) {
        if (hasAll) {
            newValue = [...allIds];
        } else {
            newValue = [];
        }
    }
    else {
        if (hasAll && selectedWithoutAll.length < allIds.length) {
            newValue = selectedWithoutAll;
        }
        
        else if (!hasAll && selectedWithoutAll.length === allIds.length - 1) {
            newValue = [{id: 'all'}, ...selectedWithoutAll];
        }
    }
    
    const newString = JSON.stringify(newValue);
    const oldString = JSON.stringify(selected);
    
    if (newString !== oldString) {
      this.estabelecimentoGerarRepasse = newValue
    }

    this.fontePagadoraGerarRepasse = newValue
    this.previousSelectedFontesPagadoras = newValue
  }

  async gerarRepasses() {
    if (this.$refs.formGerarRepasse.validate()) {
      let hasError: boolean = false

      this.loadingGerarRepasses = true
      this.statusDisparos = this.estabelecimentoGerarRepasse.filter(v => v.id != 'all').map(v => ({id: v.id, nome: v.nome, status: 'na-fila' }))

      for(let i = 0; i < this.estabelecimentoGerarRepasse.length; i++){
        const estabelecimento = this.estabelecimentoGerarRepasse[i]
        const { id } = estabelecimento
        
        if(id != 'all'){
          const index = this.statusDisparos.findIndex(item => item.id === id)
          
          this.statusDisparos[index].status = 'em-andamento'

          const response = await this.getFinanceiroStore.gerarRepasses(id)
          
          if (response.success) {
            this.statusDisparos[index].status = 'disparado'
          } else {
            hasError = true;
            this.statusDisparos[index].status = 'erro';
            this.statusDisparos[index].message = response.message || '';
          }
          await new Promise(resolve => setTimeout(resolve, 0));
        }
      }
      
      if(!hasError){
        await this.getFinanceiroStore.getGeracaoRepasseAll()
        EventBus.$emit('setSnackbar', { show: true, text: 'Repasses gerados com sucesso!', icon: 'done', color: '#2E7D32' })
        this.closeModalGerarRepasse()
      }
     this.loadingGerarRepasses = false
    }
  }

 @Watch('searchPrestador')
  async onSearchPrestadorChanged(val: string) {
    if (this.ignoreNextPrestadorSearch) {
      this.ignoreNextPrestadorSearch = false
      return
    }

    if (!val || val.length < 3){
      return
    }
    
    this.loadingPrs = true
    await this.debounce(val)
  }

  onChangePrestador() {
    this.ignoreNextPrestadorSearch = true
  }

  @Watch('getGerarRepassePrestadores')
  onPrestadoresChange() {
    this.loadingPrs = false
  }

  @Watch('modalGerarRepasse')
  async onModalGerarRepasseChange(value: boolean) {
      if (!value) {
        this.statusDisparos = []
        this.searchPrestador = ''
        this.loadingPrs = false
      }

      if (value) {
        this.autoSelectCondicaoPagamento()
      }

      this.$refs.formGerarRepasse.resetValidation()
    }

  @Watch('getCondicaoPagamento')
  onCondicaoPagamentoChange() {
    this.autoSelectCondicaoPagamento()
  }
}
